<script>
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import mixin from '@/plans/mx/shopping-cart';
import { Title as titleKey } from './pre';
export default {
  mixins: [mixin],
  methods: {
    $renderPrice() {
      return this.mx_plans.map((plan) => {
        return (
          <div class="opc-cart-item">
            {this.mx_title(
              this.$t(titleKey),
              <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>,
            )}
            {this.mx_discount(plan.plan_code)}
            <AltProratedPlanUser type={plan.type}>
              {this.mx_license(plan.cartInfo.selected_number, this.$t('billing.events.addon.co_editors'))}
            </AltProratedPlanUser>
            {this.mx_cycle(plan.billing_cycle)}
            <AltProratedPlanPeriod type={plan.type} />
            {this.mx_edit(plan)}
            {this.mx_remove(plan)}
          </div>
        );
      });
    },
    $renderAgreement() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>
